
    import { initPostHog } from "./src/utils/posthog";
    initPostHog()
  